import z from 'zod'

export const CitySchema = z
  .string()
  .min(2, 'City must be at least 2 characters long')
